import { Controller } from "@hotwired/stimulus"

// Read-only definition browser for the platform release screen. Inventory cards stay
// compact; selecting Show opens one shared details region with the chosen category.
export default class extends Controller {
  static targets = ["button", "drawer", "heading", "panel"]

  connect() {
    const match = window.location.hash.match(/^#definitions-(.+)$/)
    if (match && this.hasKind(match[1])) this.showKind(match[1], false)
  }

  show(event) {
    event.preventDefault()
    this.lastTrigger = event.currentTarget
    this.showKind(event.currentTarget.dataset.kind, true)
  }

  close() {
    this.drawerTarget.classList.add("hidden")
    this.buttonTargets.forEach((button) => {
      button.setAttribute("aria-expanded", "false")
      button.classList.remove("bg-indigo-50", "text-indigo-700")
    })
    if (window.location.hash.startsWith("#definitions-")) {
      window.history.replaceState(null, "", `${window.location.pathname}${window.location.search}`)
    }
    this.lastTrigger?.focus()
  }

  showKind(kind, scroll) {
    const activePanel = this.panelTargets.find((panel) => panel.dataset.kind === kind)
    if (!activePanel) return

    this.panelTargets.forEach((panel) => panel.classList.toggle("hidden", panel !== activePanel))
    this.buttonTargets.forEach((button) => {
      const active = button.dataset.kind === kind
      button.setAttribute("aria-expanded", active ? "true" : "false")
      button.classList.toggle("bg-indigo-50", active)
      button.classList.toggle("text-indigo-700", active)
    })
    this.headingTarget.textContent = activePanel.dataset.label
    this.drawerTarget.classList.remove("hidden")
    window.history.replaceState(null, "", `#definitions-${kind}`)

    if (scroll) {
      window.requestAnimationFrame(() => this.drawerTarget.scrollIntoView({ behavior: "smooth", block: "nearest" }))
    }
  }

  hasKind(kind) {
    return this.panelTargets.some((panel) => panel.dataset.kind === kind)
  }
}
